import Vue from "vue";
import Component from "./message.vue";
const ToastConstruer = Vue.extend(Component);

const Toast = (message, time) => {
  const instance = new ToastConstruer({
    data: {
      message,
      time: time || 1000
    }
  });
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.show();
  instance.vm.$on("closed", () => {
    document.body.removeChild(instance.vm.$el);
    instance.vm.$destroy();
  });
  return instance.vm;
};

export default Toast;



// WEBPACK FOOTER //
// ./src/components/message/index.js